var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "inherit",
    className: "arrow_svg__arrow",
    viewBox: "0 0 13 11"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.736 6.328H.656V4.456h6.08l3.056.064-3.344-4H8.64l4.16 4.864-4.16 4.896H6.48l3.344-4-3.088.048Z"
  })));
};
export { SvgArrow as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBjbGFzcz0iYXJyb3ciIHZpZXdCb3g9IjAgMCAxMyAxMSIgZmlsbD0naW5oZXJpdCcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aCBkPSJNNi43MzYgNi4zMjhIMC42NTZWNC40NTZINi43MzZMOS43OTIgNC41Mkw2LjQ0OCAwLjUySDguNjRMMTIuOCA1LjM4NEw4LjY0IDEwLjI4SDYuNDhMOS44MjQgNi4yOEw2LjczNiA2LjMyOFoiIGZpbGw9ImluaGVyaXQiLz4KPC9zdmc+";